import { ButtonVariant } from "@repo/ui/Buttons/button";
import { IconButton } from "@repo/ui/Buttons/iconButton";
import { IconPlayerPause, IconPlayerPlay } from "@tabler/icons-react";
import type { FC } from "react";
import { useAudioPlayerTrigger } from "./useAudioPlayerTrigger.js";

export interface AudioPlayerPlayButtonProps {
  sourceKey: string;
}

export const AudioPlayerPlayButton: FC<AudioPlayerPlayButtonProps> = (
  props,
) => {
  const { isPlaying, play, pause } = useAudioPlayerTrigger({
    sourceKey: props.sourceKey,
  });

  return (
    <IconButton
      variant={ButtonVariant.Tertiary}
      icon={
        isPlaying ? (
          <IconPlayerPause className="size-4 text-muted-foreground" />
        ) : (
          <IconPlayerPlay className="size-4 text-muted-foreground" />
        )
      }
      onClick={isPlaying ? pause : play}
    />
  );
};
